<template>
  <div>
    <v-card>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon x-large :color="user.cor">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ this.user.nome }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-icon small>mdi-phone</v-icon>
            <span>{{ this.user.celular }}</span>
            <v-divider inset vertical/>
            <v-icon small>mdi-email</v-icon>
            <span>{{ this.user.email }}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <div v-if="this.hasTags">
              <v-chip-group column>
                <template v-for="tag in this.tags">
                  <v-tooltip
                    bottom
                    :key="tag.id"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-on="on"
                        v-bind="attrs"
                        small
                        v-text="tag.nome"
                        :color="tag.cor"/>
                    </template>
                    <span v-text="tag.nome"></span>
                  </v-tooltip>
                </template>
              </v-chip-group>
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <tw-cadastro-user @update="onUpdate" :user="this.user">
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </tw-cadastro-user>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon small @click="onClickDelete(user)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>
    <tw-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import CadastroUser from '@/modules/user/CadastroUser.vue';

export default {
  props: {
    user: Object,
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    remove(item) {
      this.$emit('remove', item);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este usuário?',
        `O usuário ${item.nome} será removido e esta operação não pode ser desfeita.`,
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
  computed: {
    tags: {
      get() {
        if (this.user && this.user.tags) {
          return this.user.tags;
        }
        return [];
      },
    },
    hasTags: {
      get() {
        return this.tags.length > 0;
      },
    },
  },
  components: {
    TwCadastroUser: CadastroUser,
  },
};
</script>
